import { useParams } from 'react-router-dom';
import { useProject } from '../api/projects.js';

interface BreadcrumbItem {
	label: string;
	href?: string;
}

const RESOURCE_PATHS: Record<string, string> = {
	Experiments: 'experiments',
	Flags: 'flags',
	Submissions: 'submissions',
	'Exclusion Groups': 'exclusion-groups',
	Events: 'events',
};

export function useProjectBreadcrumbs(...segments: string[]): BreadcrumbItem[] {
	const { id } = useParams();
	const { data: project } = useProject(id ?? '');
	const projectLabel = project?.name ?? id ?? '';

	const crumbs: BreadcrumbItem[] = [
		{ label: 'Projects', href: '/projects' },
		{ label: projectLabel, href: `/projects/${id}` },
	];

	for (let i = 0; i < segments.length; i++) {
		const segment = segments[i] ?? '';
		const isLast = i === segments.length - 1;
		const path = RESOURCE_PATHS[segment];

		if (isLast && !path) {
			crumbs.push({ label: segment });
		} else if (path) {
			crumbs.push({ label: segment, href: `/projects/${id}/${path}` });
		} else {
			crumbs.push({ label: segment });
		}
	}

	return crumbs;
}
